import { Component, EventEmitter, Input,OnInit, Output} from '@angular/core';
import { Item } from './interfaces/interfaces';
import { ItemOrder } from 'src/app/lem/models/common/item-order';

@Component({
  selector: 'app-pick-list',
  templateUrl: './pick-list.component.html',
  styleUrls: ['./pick-list.component.scss']
})
export class PickListComponent implements OnInit {

  @Input() values: ItemOrder<Item>[];
  @Output() valuesChange = new EventEmitter<ItemOrder<Item>[]>();
  @Input() targetValues: ItemOrder<Item>[] = [];
  @Input() labelFrom: string;
  @Input() labelTo: string;
  @Input() filterBy: string;
  @Input() filterByLabel: string;

  constructor() { }

  ngOnInit() {
  }

  onChange(){
    let count = 1
    this.targetValues.forEach(element => {
      element.order = count
      count ++;
    });
    this.valuesChange.emit(this.targetValues);
  }

  isTargetValue(item: ItemOrder<Item>): boolean {
    return this.targetValues.find(target => target == item) !== undefined ? true : false;
  }

}
